import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=17b42fa5&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=ts"
export * from "./DetailPage.vue?vue&type=script&lang=ts"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=17b42fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b42fa5",
  null
  
)

export default component.exports